import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import {
    type PaletteSwitcherIconColorConstantType,
    type PaletteSwitcherDotColorConstantType,
    type PaletteSwitcherDynamicStyleType,
    type PaletteSwitcherDefaultKey
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getButtonCustomColor
} from "../button/stylesheet";

export const PALETTE_SWITCHER_DEFAULT_KEYS: Array<PaletteSwitcherDefaultKey> = [
    "nibgat",
    "nibgat-community",
    "caycore"
];

export const PALETTE_SWITCHER_TITLE_KEYS: Record<PaletteSwitcherDefaultKey, keyof NCoreUIKit.Translation> = {
    "nibgat-community": "palette-switcher-nibgat-community",
    caycore: "palette-switcher-caycore",
    nibgat: "palette-switcher-nibgat"
};

export const getPaletteSwitcherIconColor = ({
    isCustomIconColor,
    buttonIconColor,
    isDisabled,
    iconColor,
    colors
}: PaletteSwitcherIconColorConstantType): string | undefined => {
    if(isDisabled || isCustomIconColor || !iconColor) {
        return buttonIconColor;
    }

    return getButtonCustomColor({
        customColor: iconColor,
        colors
    });
};

export const getPaletteSwitcherDotColor = ({
    buttonIconColor,
    paletteColor,
    isDisabled,
    iconColor,
    colors
}: PaletteSwitcherDotColorConstantType): string | undefined => {
    if(isDisabled) {
        return buttonIconColor;
    }

    if(iconColor) {
        return getButtonCustomColor({
            customColor: iconColor,
            colors
        });
    }

    return paletteColor ?? buttonIconColor;
};

const stylesheet = StyleSheet.create({
    dot: {
        flexShrink: 0
    }
});

export const useStyles = ({
    isShowBorder,
    dotColor,
    radiuses,
    borders,
    colors,
    size
}: PaletteSwitcherDynamicStyleType) => {
    const styles = {
        dot: {
            borderRadius: radiuses.full,
            backgroundColor: dotColor,
            height: size,
            width: size
        } as Mutable<ViewStyle>
    };

    if(isShowBorder) {
        styles.dot.borderColor = colors.content.border.subtle;
        styles.dot.borderWidth = borders.line;
    }

    return styles;
};
export default stylesheet;
